// @ts-nocheck
(function () {
  const dataEl = document.getElementById('product-variants-badge-data');
  if (!dataEl) return;

  let data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) { return; }

  function primaryMarkupEmpty() {
    const first = document.querySelector('.product-page-badge__primary');
    return !first || first.innerHTML.trim() === '';
  }

  function getOrderQuantity() {
    const quantityInput = document.querySelector(
      'quantity-selector-component input[ref="quantityInput"], form[action="/cart/add"] input[name="quantity"]'
    );
    return quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
  }

  function isPreorderVariant(variant) {
    if (!variant || !variant.available) return false;
    const inv = variant.inventoryQuantity;
    if (typeof inv !== 'number' || Number.isNaN(inv)) return false;
    const orderQty = getOrderQuantity();
    if (variant.inventoryPolicy === 'continue') {
      return orderQty > Math.max(0, inv);
    }
    return inv <= 0;
  }

  function updateNewInBadge(variantId) {
    if (!data.productHasAnyNewIn) return;
    const variant = data.variants.find(function (v) { return Number(v.id) === Number(variantId); });
    const showNewIn = variant && (variant.newIn === true || variant.newIn === 'true');
    const primaryEmpty = primaryMarkupEmpty();

    document.querySelectorAll('.product-page-badge__newin').forEach(function (newInWrap) {
      newInWrap.style.display = showNewIn ? '' : 'none';
      const newInBadge = newInWrap.querySelector('.product-card__badge');
      if (newInBadge) {
        newInBadge.classList.toggle('product-card__badge--new-in--alone', showNewIn && primaryEmpty);
      }
    });
  }

  function updateBadge(variantId) {
    // Made-to-order is tag-based — primary badge never changes via JS
    if (data.isMadeToOrder) {
      updateNewInBadge(variantId);
      return;
    }

    let show = false;

    if (data.deliveryNoticeEnabled && variantId) {
      const variant = data.variants.find(function (v) { return Number(v.id) === Number(variantId); });
      if (!variant) {
        updateNewInBadge(variantId);
        return;
      }

      show = isPreorderVariant(variant);
    }

    const primaryHtml = show
      ? '<span class="product-card__badge" style="background-color:#ffffff; color:#000000;">Pre-Order</span>'
      : '';

    document.querySelectorAll('.product-page-badge__primary').forEach(function (el) {
      el.innerHTML = primaryHtml;
    });

    updateNewInBadge(variantId);
    updateAddToCartLabels(variantId, show);
  }

  function setButtonLabel(button, label) {
    if (!button) return;
    const textNode = button.querySelector('.add-to-cart-text__content span');
    if (textNode) textNode.textContent = label;
  }

  function updateAddToCartLabels(variantId, isPreorder) {
    const variant = data.variants.find(function (v) { return Number(v.id) === Number(variantId); });
    if (!variant) return;

    if (!variant.available) {
      return;
    }

    const shouldUseOrderLabel = data.isMadeToOrder || isPreorder;
    const label = shouldUseOrderLabel ? 'Order' : 'Add to Cart';

    // Main product add-to-cart button
    const mainButton = document.querySelector('form[action="/cart/add"] [ref="addToCartButton"], #addToCart button');
    setButtonLabel(mainButton, label);

    // Sticky add-to-cart button
    const stickyButton = document.querySelector('sticky-add-to-cart .sticky-add-to-cart__button');
    setButtonLabel(stickyButton, label);
  }

  // Your theme's variant input (the hidden <input name="id"> updated by swatch clicks)
  const variantInput = document.querySelector('form[action="/cart/add"] input[name="id"], form[id*="product"] input[name="id"]');

  let lastId = null;

  function handleVariantChange(id) {
    const parsed = parseInt(id, 10);
    if (!parsed || parsed === lastId) return;
    lastId = parsed;
    updateBadge(parsed);
  }

  function getCurrentVariantId() {
    return (
      lastId ||
      parseInt(new URLSearchParams(window.location.search).get('variant') || '', 10) ||
      (variantInput ? parseInt(variantInput.value, 10) : 0) ||
      data.selectedVariantId
    );
  }

  // 1. Native change event on the variant input
  if (variantInput) {
    variantInput.addEventListener('change', function () {
      handleVariantChange(this.value);
    });
  }

  // 2. MutationObserver — catches programmatic value updates (swatch JS)
  if (variantInput && window.MutationObserver) {
    new MutationObserver(function () {
      handleVariantChange(variantInput.value);
    }).observe(variantInput, { attributes: true, attributeFilter: ['value'] });
  }

  // 3. Horizon theme dispatches variant:update on <variant-picker>
  document.addEventListener('variant:update', function (e) {
    const resource = e.detail && e.detail.resource;
    if (resource && resource.id) {
      handleVariantChange(resource.id);
    }
  });

  document.addEventListener('variant:changed', function (e) {
    if (e.detail && e.detail.variant) {
      handleVariantChange(e.detail.variant.id);
    }
  });

  document.addEventListener('change', function (e) {
    const target = e.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (target.matches('quantity-selector-component input[ref="quantityInput"], form[action="/cart/add"] input[name="quantity"]')) {
      updateBadge(getCurrentVariantId());
    }
  });

  // 4. URL watcher — fallback for themes that update ?variant= param
  window.addEventListener('popstate', function () {
    const id = new URLSearchParams(window.location.search).get('variant');
    if (id) handleVariantChange(id);
  });

  // Init: use URL param first, then fall back to input value
  const initId =
    new URLSearchParams(window.location.search).get('variant') ||
    (variantInput && variantInput.value);
  if (initId) {
    lastId = parseInt(initId, 10);
    updateBadge(lastId);
  }
})();
